
import config from "@/assets/config";
import { proyecto } from "@/mixins/proyecto.mixins.js";
export default {
  mixins: [proyecto],
  props: {
    minWidth: { type: String, default: "25" },
    maxWidth: { type: String, default: "200" },
    minHeight: { type: String, default: "25" },
    maxHeight: { type: String, default: "200" },
    width: { type: String, default: "150" },
    height: { type: String, default: "150" },
    img: { type: Boolean, default: false }
  },
  computed: {
    logoUrl() {
      try {
        const user = this.getStateData("user");
        if (user && user.entity && user.entity.docnumber && user.entity.logo) {
          return `${config.api_no_proxy.archivos}${user.entity.docnumber}/public/logo.png`;
        }
        const pv = this.proyecto_v;
        if (pv && pv.codenumber && pv.logo) {
          return `${config.api_no_proxy.archivos}${pv.codenumber}/public/logo.png`;
        }
      } catch (e) {
        console.warn("No se pudo construir la URL del logo:", e);
      }
      return this.url_logo;
    }
  }
};
